import { CollectionScope, collectionScope } from '@nemuru-eng/js-api-client';

import { useUser } from '@/hooks/useUser';

/**
 * Scope of the real-time collection topics the authenticated user may subscribe to.
 * Mirrors the filters the API applies to list endpoints per user type; users without a
 * single scope (merchant group, partner, …) get undefined and simply do not subscribe.
 */
export const useCollectionScope = (): CollectionScope | undefined => {
  const { userEntity, structure, currentChannel, agent, isUserAdmin, isUserMerchant, isUserChannel, isUserAgent } =
    useUser();

  try {
    if (isUserAdmin) return collectionScope.all();
    if (isUserMerchant && structure?.merchant?.id) return collectionScope.merchant(structure.merchant.id);
    const channelId = currentChannel?.id ?? userEntity?.channel?.id;
    if (isUserChannel && channelId) return collectionScope.channel(channelId);
    const agentId = agent?.id ?? userEntity?.agent?.id;
    if (isUserAgent && agentId) return collectionScope.agent(agentId);
  } catch {
    // a non-uuid id (should not happen) must never break the page: just no live updates
  }
  return undefined;
};
